import { Injectable } from '@angular/core';
import { DeviceSubscriptionOfferExt } from 'src/app/generated/CrossPoint.License.Server';

@Injectable()
export class LicenseFormatterService {

  constructor() { }
  
  public getFormattedLicenseTitle(license: DeviceSubscriptionOfferExt): string {
    if (license.store.address.city) {
      return `${license.store.name}, ${license.store.address.city}`;
    }

    if(license.store.name){
      return `${license.store.name}`;
    }

    return  `${license.serial}`;   
  }

  public getFormattedLicenseSubTitle(license: DeviceSubscriptionOfferExt): string {
    let subTitle = license.serial;
    if (license.store.address.street) {
      subTitle += ` - ${license.store.address.street} ${license.store.address.streetNumber}`;
    }
  
    return subTitle;
  }
}
